<form class="flexer padding">
  <mat-card class="internal-form mat-elevation-z0">
    <div class="internal-form-title">
      <div class="internal-form-title-text">Intern</div>
    </div>

    <div class="form-title">
      <div class="form-title-text">Locatie en uitvoering</div>
    </div>

    <div class="form-sub-title">Afstand tot locatie</div>

    <mat-form-field appearance="outline">
      <mat-label>Kilometer</mat-label>

      <input
        matInput
        type="number"
        [(ngModel)]="inputProject.projectPlacement.kilometersTo"
        (ngModelChange)="kilometersToChanged()"
        [ngModelOptions]="{ standalone: true }"
      />
    </mat-form-field>

    <textarea-input
      [title]="'Hoe plaatsen'"
      [placeholder]="'45°, parallel'"
      [initContent]="inputProduct.placeInstructions"
      (answer)="placeInstructionsChange($event)"
    ></textarea-input>

    <textarea-input
      [title]="'Afstand voorste paal tot straat'"
      [placeholder]="'Info afstand voorste paal tot straat'"
      [initContent]="inputProduct.distanceFrontPostToStreet"
      (answer)="distanceFrontPostToStreetChanged($event)"
    ></textarea-input>

    <yes-no
      [title]="'Houten palen'"
      [neverShowExtraInstructions]="true"
      [value]="placement.newWoodPosts"
      [yesValue]="'Nieuw hout'"
      [noValue]="'Recup hout'"
      [nullIsFalse]="false"
      [nullable]="true"
      (answer)="newWoodPostsChange($event)"
    >
    </yes-no>

    <yes-no
      [title]="'Zijn er obstakels'"
      [showExtraInstructionsOn]="'Ja'"
      [nullIsFalse]="false"
      [nullable]="true"
      [value]="placement.obstaclesPresent"
      [inputText]="placement.obstaclesInfo"
      [extraInstructions]="
        'Is er een omheining of zijn er herashekken? Staan er dieren in de wei?'
      "
      (answer)="obstaclesPresentChange($event)"
      (answeredText)="obstaclesInfoTextChange($event)"
    >
    </yes-no>

    <yes-no
      *ngIf="showNearbyParkingQuestion"
      [title]="'Kan er vlakbij geparkeerd worden'"
      [showExtraInstructionsOn]="'Ja'"
      [nullIsFalse]="false"
      [nullable]="true"
      [value]="placement.canParkNearby"
      [inputText]="placement.nearbyParkingInfo"
      [extraInstructions]="'Geef meer informatie aub.'"
      (answer)="canParkNearbyChanged($event)"
      (answeredText)="nearbyParkingInfoChanged($event)"
    >
    </yes-no>

    <textarea-input
      [title]="'Info voor de installateur'"
      [placeholder]="'Interne info. Klant leest niet mee.'"
      [initContent]="inputProduct.productPlacement.installerInfo"
      (answer)="installerInfoChange($event)"
    ></textarea-input>

    <div class="form-title">
      <div class="form-title-text">Externe leverancier</div>
    </div>

    <yes-no
      [title]="'Hoogwerker'"
      [showExtraInstructionsOn]="'Ja'"
      [value]="inputProduct.productPlacement.extraHoogwerker"
      [nullable]="true"
      [nullIsFalse]="false"
      [inputText]="inputProduct.productPlacement.extraHoogwerkerDescription"
      [done]="inputProduct.productPlacement.extraHoogwerkerDone"
      [extraInstructions]="'Type hoogwerker, ...'"
      (answer)="hoogwerkerChanged($event)"
      (answeredText)="hoogwerkerTextChanged($event)"
      (doneAnswered)="hoogwerkerDoneChanged($event)"
    >
    </yes-no>

    <div
      *ngIf="inputProduct.productPlacement.extraHoogwerker"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="hoogwerkerEmployee"
            required
            [(ngModel)]="inputProduct.productPlacement.extraHoogwerkerEmployee"
            (ngModelChange)="extraHoogwerkerEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="left-space">
        <div class="form-sub-title">Deadline</div>

        <mat-form-field appearance="outline">
          <input
            #extraHoogwerkerDeadlineInput
            matInput
            [matDatepicker]="extraHoogwerkerDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="inputProduct.productPlacement.extraHoogwerkerDeadline"
            (dateChange)="extraHoogwerkerDeadlineChange($event)"
          />

          <mat-datepicker-toggle
            matSuffix
            [for]="extraHoogwerkerDeadlinePicker"
          ></mat-datepicker-toggle>

          <mat-datepicker #extraHoogwerkerDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <yes-no
      [title]="'Parkeerverbod'"
      [value]="inputProduct.productPlacement.parkingBan"
      [nullable]="true"
      [nullIsFalse]="false"
      [done]="inputProduct.productPlacement.parkingBanDone"
      (answer)="parkingBanChanged($event)"
      [inputText]="inputProduct.productPlacement.extraInfoParkingBan"
      (answeredText)="extraInfoParkingBanChanged($event)"
      (doneAnswered)="ParkingBanDoneChanged($event)"
    ></yes-no>

    <div
      *ngIf="inputProduct.productPlacement.parkingBan"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="parkingBanEmployee"
            required
            [(ngModel)]="inputProduct.productPlacement.parkingBanEmployee"
            (ngModelChange)="parkingBanEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="left-space">
        <div class="form-sub-title">Deadline</div>

        <mat-form-field appearance="outline">
          <input
            #parkingBanDeadlineInput
            matInput
            [matDatepicker]="parkingBanDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="inputProduct.productPlacement.parkingBanDeadline"
            (dateChange)="parkingBanDeadlineChange($event)"
          />

          <mat-datepicker-toggle
            matSuffix
            [for]="parkingBanDeadlinePicker"
          ></mat-datepicker-toggle>

          <mat-datepicker #parkingBanDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <yes-no
      [title]="'Extra leverancier nodig'"
      [showExtraInstructionsOn]="'Ja'"
      [value]="inputProduct.productPlacement.needExtraSupplier"
      [nullable]="true"
      [nullIsFalse]="false"
      [done]="inputProduct.productPlacement.needExtraSupplierDone"
      [inputText]="inputProduct.productPlacement.extraInfoNeedExtraSupplier"
      [extraInstructions]="'Geef meer informatie aub'"
      (answer)="needExtraSupplierChange($event)"
      (answeredText)="extraInfoNeedExtraSupplierChange($event)"
      (doneAnswered)="needExtraSupplierDoneChange($event)"
    >
    </yes-no>

    <div
      *ngIf="inputProduct.productPlacement.needExtraSupplier"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="extraSupplierEmployee"
            required
            [(ngModel)]="inputProduct.productPlacement.extraSupplierEmployee"
            (ngModelChange)="extraSupplierEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="left-space">
        <div class="form-sub-title">Deadline</div>

        <mat-form-field appearance="outline">
          <input
            #extraSupplierDeadlineInput
            matInput
            [matDatepicker]="extraSupplierDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="inputProduct.productPlacement.extraSupplierDeadline"
            (dateChange)="extraSupplierDeadlineChange($event)"
          />

          <mat-datepicker-toggle
            matSuffix
            [for]="extraSupplierDeadlinePicker"
          ></mat-datepicker-toggle>

          <mat-datepicker #extraSupplierDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <yes-no
      [title]="'Extra materialen nodig'"
      [showExtraInstructionsOn]="'Ja'"
      [value]="inputProduct.productPlacement.needExtraMaterials"
      [nullable]="true"
      [nullIsFalse]="false"
      [done]="inputProduct.productPlacement.needExtraMaterialsDone"
      [inputText]="inputProduct.productPlacement.extraInfoNeedExtraMaterials"
      [extraInstructions]="'Geef meer informatie aub'"
      (answer)="needExtraMaterialsChange($event)"
      (answeredText)="extraInfoNeedExtraMaterialsChange($event)"
      (doneAnswered)="needExtraMaterialsDoneChange($event)"
    >
    </yes-no>

    <div
      *ngIf="inputProduct.productPlacement.needExtraMaterials"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="extraMaterialsEmployee"
            required
            [(ngModel)]="inputProduct.productPlacement.extraMaterialsEmployee"
            (ngModelChange)="extraMaterialsEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="left-space">
        <div class="form-sub-title">Deadline</div>

        <mat-form-field appearance="outline">
          <input
            #extraMaterialsDeadlineInput
            matInput
            [matDatepicker]="extraMaterialsDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="inputProduct.productPlacement.extraMaterialsDeadline"
            (dateChange)="extraMaterialsDeadlineChange($event)"
          />

          <mat-datepicker-toggle
            matSuffix
            [for]="extraMaterialsDeadlinePicker"
          ></mat-datepicker-toggle>

          <mat-datepicker #extraMaterialsDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="form-title">
      <div class="form-title-text">SketchUp & materialen</div>
    </div>

    <div class="bottom-space">
      <load-list
        [product]="inputProduct"
        (update)="outputProduct.emit()"
      ></load-list>
    </div>

    <div class="form-title">
      <div class="form-title-text">Plaatsing</div>
    </div>

    <div
      *ngIf="nbInstallersRequired != null && nbInstallersRequired > 0"
      class="italics-text bottom-space"
    >
      {{ nbInstallersRequired }} installateur(s) nodig
    </div>

    <form class="form">
      <div class="d-flex">
        <div>
          <div class="form-sub-title">Naam medewerker(s)</div>

          <mat-form-field class="" appearance="outline">
            <mat-select
              matInput
              multiple
              placeholder="Maak een keuze"
              name="placer"
              required
              [(ngModel)]="inputProduct.productPlacement.placers"
              (ngModelChange)="placerChange()"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of employeeChoices"
                [value]="option"
              >
                {{ option.user.firstName }} {{ option.user.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-grow-1">
          <div class="form-field form-sub-title">Gekozen medewerker(s)</div>

          <p
            class="title-top form-field"
            *ngIf="
              inputProduct.productPlacement.placers == null ||
              inputProduct.productPlacement.placers.length === 0
            "
          >
            Geen medewerkers gekozen
          </p>

          <ul
            class="form-field"
            *ngIf="
              inputProduct.productPlacement.placers != null &&
              inputProduct.productPlacement.placers.length > 0
            "
          >
            <li
              *ngFor="let placer of this.inputProduct.productPlacement.placers"
            >
              {{ placer.user.firstName }} {{ placer.user.lastName }}
            </li>
          </ul>
        </div>
      </div>
    </form>

    <div class="title">Plaatsingsdatum</div>

    <div class="d-flex small-upper-space">
      <p>Gekozen door klant: {{ requestedDateDisplay }}</p>

      <button
        *ngIf="
          !inputProject.projectPlacement?.placeASAP &&
          inputProject.projectPlacement?.placementEarliestDate != null
        "
        type="button"
        mat-button
        class="copy-button"
        (click)="copyProjectPlacementDate()"
      >
        Neem datum over
      </button>
    </div>

    <div *ngIf="!inputProduct.productPlacement.placeASAP" class="d-flex">
      <mat-form-field appearance="outline">
        <input
          #actualPlacementInput
          matInput
          [matDatepicker]="actualPlacementPicker"
          placeholder="Selecteer een datum"
          [value]="inputProduct.productPlacement.actualPlacementDate"
          [disabled]="
            inputProduct.productPlacement.actualPlacementDateConfirmed
          "
          (dateChange)="actualPlacementDateChange($event)"
        />

        <mat-datepicker-toggle
          matSuffix
          [for]="actualPlacementPicker"
        ></mat-datepicker-toggle>

        <mat-datepicker #actualPlacementPicker></mat-datepicker>
      </mat-form-field>

      <div class="align-placement-date-confirmed-checkbox">
        <checkbox
          [checked]="inputProduct.productPlacement.actualPlacementDateConfirmed"
          [text]="'Datum vastzetten'"
          [isDisabled]="
            inputProduct.productPlacement.actualPlacementDate == null
          "
          (answer)="actualPlacementDateConfirmedChange($event)"
        ></checkbox>
      </div>
    </div>

    <div class="form-sub-title">Voorziene tijd installateur</div>

    <form class="form">
      <div class="d-flex">
        <div class="timeInput">
          <div class="selector-label">Uren</div>

          <mat-form-field class="timeInput" appearance="outline">
            <mat-select
              matInput
              class="timeInputSelect"
              required
              [(ngModel)]="inputProduct.productPlacement.installerHourBudget"
              name="installerHourBudget"
              (ngModelChange)="setHours()"
              [compareWith]="compareNumbers"
            >
              <mat-option
                *ngFor="let option of hours"
                [value]="option"
                class="timeInputSelect"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="largeText">:</div>

        <div class="timeInput">
          <div class="selector-label">Minuten</div>

          <mat-form-field class="timeInput" appearance="outline">
            <mat-select
              matInput
              class="timeInputSelect"
              required
              [(ngModel)]="inputProduct.productPlacement.installerMinuteBudget"
              name="installerMinuteBudget"
              (ngModelChange)="setMinutes()"
              [compareWith]="compareNumbers"
            >
              <mat-option
                *ngFor="let option of minutes"
                [value]="option"
                class="timeInputSelect"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>

    <div class="form-title">
      <div class="form-title-text">Uitvoering plaatsing</div>
    </div>

    <textarea-input
      [title]="'Feedback installateur'"
      [placeholder]="'Feedback van de installateur omtrent de plaatsing'"
      [initContent]="inputProduct.productPlacement.installerFeedback"
      (answer)="installerFeedbackChange($event)"
    ></textarea-input>

    <file-picker
      [title]="'Voeg afbeelding(en) van uitvoering toe'"
      [inputProduct]="inputProduct"
      [formSection]="'execution'"
    ></file-picker>

    <yes-no
      [title]="'Uitgevoerd'"
      [yesValue]="'Project werd uitgevoerd'"
      [noValue]="'Project werd niet uitgevoerd'"
      [showExtraInstructionsOn]="'Project werd niet uitgevoerd'"
      [value]="inputProduct.productPlacement.executionComplete"
      [inputText]="inputProduct.productPlacement.executionCompleteInfo"
      [extraInstructions]="'Reden niet uitgevoerd'"
      [nullIsFalse]="false"
      [nullable]="true"
      (answer)="executionCompleteChange($event)"
      (answeredText)="executionCompleteInfoChange($event)"
    >
    </yes-no>

    <div class="logged-action-vertical-offset">
      <logged-action-display
        *ngIf="inputProduct.productPlacement.placedRegistration"
        [inputLoggedAction]="inputProduct.productPlacement.placedRegistration"
      ></logged-action-display>

      <ng-container
        *ngIf="inputProject.projectPlacement.registeredActions?.length > 0"
      >
        <registered-action-display
          *ngFor="
            let registeredAction of inputProject.projectPlacement
              .registeredActions;
            trackBy: trackById
          "
          [inputRegisteredAction]="registeredAction"
        ></registered-action-display>
      </ng-container>
    </div>

    <div class="title">Registreer datum en uur</div>

    <div class="yop-space">
      <mat-form-field class="first-form-field" appearance="outline">
        <input
          matInput
          [matDatepicker]="executionPicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="inputProduct.productPlacement.executionDate"
          (ngModelChange)="executionDateChange()"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="invoiceDisables"
        />

        <mat-datepicker-toggle
          [disabled]="invoiceDisables"
          matSuffix
          [for]="executionPicker"
        ></mat-datepicker-toggle>

        <mat-datepicker #executionPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-field" appearance="outline">
        <input
          matInput
          [ngModel]="executionTime"
          placeholder="Selecteer een tijdstip"
          [ngxMatTimepicker]="executionTimepicker"
          [format]="24"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="executionTimeChange($event)"
          [disabled]="invoiceDisables"
          readonly
        />

        <ngx-mat-timepicker #executionTimepicker></ngx-mat-timepicker>
      </mat-form-field>
    </div>
  </mat-card>
</form>
